import { Panel } from 'primereact/panel';
import React, { useEffect, useState } from 'react';

import DisputeNeedsReviewPillstatus from '../../../assets/DisputeNeedsReviewPillstatus.png';
import DisputeReviewedPillStatus from '../../../assets/DisputeReviewedPillStatus.png';
import { PillStatus } from '../../../components/pillsStatus/PillStatus';
import { ScorecardDisputesTable } from '../../../components/scorecardDisputesTable/ScorecardDisputesTable';
import { useGetScoreCardDisputesQuery } from '../../../pages/scorecardDashboard/scorecardDashboardSlice';
import { ConstApprovalWindowStatus } from '../../../utils/typeConstants';
import { useGetPrimaryApprovalWindowQuery } from '../../../pages/compensation/compensationSlice';

interface PropTypes {
    scorecardVersion?: number;
    inputyear?: any;
    inputmonth?: any;
    scoreCardDisputesDataValue: (e: []) => void;
}

const TeamLeadScorecardDispute = ({
    scorecardVersion,
    inputyear,
    inputmonth,
    scoreCardDisputesDataValue,
}: PropTypes) => {
    const [scDisputesPill, setScDisputesPill] = useState({ status: '', icon: '', tooltip: '', bgColor: '' });
    const [isMangerWindowOpen, setIsMangerWindowOpen] = useState<boolean>(false);
    const { data: scoreCardDisputesData } = useGetScoreCardDisputesQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
        },

        { skip: !scorecardVersion }
    );
    const { data: primaryApprovalWindowData } = useGetPrimaryApprovalWindowQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
            approvalWindowConfigLevelId: 3,
        },
        { skip: !inputyear || !inputmonth || !scorecardVersion }
    );
    useEffect(() => {
        scoreCardDisputesDataValue(scoreCardDisputesData);
        if (scoreCardDisputesData?.data) {
            const disputedRow = scoreCardDisputesData?.data.filter((x: any) => {
                if (x.disputeStatus === 'Open') return x;
                else return '';
            });
            if (disputedRow.length > 0) {
                setScDisputesPill({
                    status: 'Disputed',
                    icon: DisputeNeedsReviewPillstatus,
                    tooltip: ' Please resolve scorecard disputes',
                    bgColor: '#E23636',
                });
            } else
                setScDisputesPill({
                    status: 'Reviewed',
                    icon: DisputeReviewedPillStatus,
                    tooltip: ' All Reviewed.',
                    bgColor: '#64d96e',
                });
        } else setScDisputesPill({ status: '', icon: '', tooltip: '', bgColor: '' });
    }, [scoreCardDisputesData]);

    useEffect(() => {
        if (primaryApprovalWindowData?.data?.length > 0) {
            const approvalWindowStatusId = primaryApprovalWindowData?.data[0]?.approval_window_status_id;           
            if (approvalWindowStatusId === ConstApprovalWindowStatus.APPROVALS_NOT_STARTED) {
                setIsMangerWindowOpen(false);
            } else {
                setIsMangerWindowOpen(true);
            }
        } else {
            setIsMangerWindowOpen(false);
        }
    }, [scorecardVersion, primaryApprovalWindowData]);

    return (
        <Panel
            headerTemplate={(options) =>
                // scorecardDisputeHeader(options, 'Scorecard Disputes', scDisputesPill)
                PillStatus({ options,  Headertext:'Scorecard Disputes' , pillDetails:scDisputesPill })
            }
            className="approvalPanel card mt-4 shadow bg-body rounded border-0"
            toggleable collapsed
        >
            <ScorecardDisputesTable
                scorecardVersion={scorecardVersion}
                data={scoreCardDisputesData?.data}
                isMangerWindowOpen={isMangerWindowOpen}
            />
        </Panel>
    );
};

export default TeamLeadScorecardDispute;
